const cards = [
  {
    title: '韩漫推荐',
    desc: '精选韩国漫画热门作品，从热血到恋爱全覆盖，每日更新最新韩漫资源。',
    icon: 'ri-kakao-talk-fill',
    color: 'bg-accent-100 text-accent-600',
    imageUrl: 'https://readdy.ai/api/search-image?query=Manga%20themed%20illustration%20with%20Korean%20webtoon%20style%20characters%2C%20vibrant%20warm%20colors%2C%20vertical%20scroll%20comic%20aesthetic%2C%20clean%20cream%20background%2C%20modern%20editorial%20style&width=480&height=320&seq=card-kr-01&orientation=landscape',
  },
  {
    title: '日漫大全',
    desc: '经典日漫一网打尽，从昭和名作到令和话题作，构建最完整的日漫阅读库。',
    icon: 'ri-global-fill',
    color: 'bg-primary-100 text-primary-600',
    imageUrl: 'https://readdy.ai/api/search-image?query=Manga%20themed%20illustration%20with%20Japanese%20manga%20style%20characters%2C%20vibrant%20warm%20colors%2C%20black%20and%20white%20comic%20page%20aesthetic%2C%20clean%20cream%20background%2C%20modern%20editorial%20style&width=480&height=320&seq=card-jp-02&orientation=landscape',
  },
  {
    title: '国漫排行榜',
    desc: '国产漫画精品力作排行，见证国漫崛起，发现最具潜力的国产漫画新星。',
    icon: 'ri-flag-2-fill',
    color: 'bg-secondary-100 text-secondary-600',
    imageUrl: 'https://readdy.ai/api/search-image?query=Manga%20themed%20illustration%20with%20Chinese%20manhua%20style%20characters%2C%20vibrant%20warm%20colors%2C%20colorful%20comic%20panel%20aesthetic%2C%20clean%20cream%20background%2C%20modern%20editorial%20style&width=480&height=320&seq=card-cn-03&orientation=landscape',
  },
  {
    title: '热血战斗',
    desc: '燃到爆炸的战斗漫画专区，超燃打斗场面、感人伙伴情谊，让你肾上腺素飙升。',
    icon: 'ri-fire-fill',
    color: 'bg-accent-100 text-accent-600',
    imageUrl: 'https://readdy.ai/api/search-image?query=Manga%20themed%20illustration%20with%20action%20battle%20style%20characters%2C%20vibrant%20warm%20colors%2C%20dynamic%20action%20lines%20aesthetic%2C%20clean%20cream%20background%2C%20modern%20editorial%20style&width=480&height=320&seq=card-action-04&orientation=landscape',
  },
  {
    title: '甜蜜恋爱',
    desc: '温馨甜蜜的恋爱漫画合集，从校园到职场，每一个心动瞬间都值得被珍藏。',
    icon: 'ri-heart-fill',
    color: 'bg-primary-100 text-primary-600',
    imageUrl: 'https://readdy.ai/api/search-image?query=Manga%20themed%20illustration%20with%20romance%20style%20characters%2C%20soft%20warm%20colors%2C%20gentle%20pastel%20comic%20aesthetic%2C%20clean%20cream%20background%2C%20modern%20editorial%20style&width=480&height=320&seq=card-romance-05&orientation=landscape',
  },
  {
    title: '悬疑烧脑',
    desc: '高智商对决与烧脑剧情，精选悬疑推理漫画，每翻一页都让你屏住呼吸。',
    icon: 'ri-lightbulb-flash-fill',
    color: 'bg-secondary-100 text-secondary-600',
    imageUrl: 'https://readdy.ai/api/search-image?query=Manga%20themed%20illustration%20with%20mystery%20suspense%20style%20characters%2C%20darker%20warm%20colors%2C%20dramatic%20comic%20panel%20aesthetic%2C%20clean%20cream%20background%2C%20modern%20editorial%20style&width=480&height=320&seq=card-mystery-06&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">漫画分类大全</h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            精准<strong>漫画分类</strong>体系，从韩漫推荐到日漫大全国漫排行榜，轻松找到<strong>好看的漫画</strong>
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cards.map((card) => (
            <div
              key={card.title}
              className="group overflow-hidden rounded-xl border border-background-200/60 bg-background-50 hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <div className="h-40 md:h-44 overflow-hidden">
                <img
                  src={card.imageUrl}
                  alt={card.title}
                  title={`${card.title} - 土豪漫画网漫画分类`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-3 mb-3">
                  <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${card.color}`}>
                    <i className={`${card.icon} text-lg`}></i>
                  </div>
                  <h3 className="font-serif font-semibold text-base text-foreground-900 group-hover:text-primary-500 transition-colors">
                    {card.title}
                  </h3>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}